export default () => ({
    items: [],
    liveItems: [],
    liveFreshItem: false,
    paymentData: null,
    promoDiscount: 0,
    promoTotalWithDiscount: 0,
    promoTotal: 0,
    promoPercent: 0,
    promoValue: "",
    promoMessage: "",
    promoType: "",
    isCartOpenState: false,
    promoData: null,
    appliedBonuses: 0,
    discountInfo: {
        isApply: false,
        discountType: "",
    },
    isDeliveresLoading: false,
    QRCodeModal: null,

});
